import { all, takeEvery } from 'redux-saga/effects';

import services from '../services';
import EntryActionTypes from '../../../constants/EntryActionTypes';

export default function* contentCardDefaultsWatchers() {
  yield all([
    takeEvery(EntryActionTypes.CONTENT_CARD_DEFAULTS_IN_CURRENT_BOARD_FETCH, () =>
      services.fetchContentCardDefaultsInCurrentBoard(),
    ),
    takeEvery(EntryActionTypes.CONTENT_CARD_DEFAULT_IN_CURRENT_BOARD_CREATE, ({ payload: { type, data } }) =>
      services.createContentCardDefaultInCurrentBoard(type, data),
    ),
    takeEvery(EntryActionTypes.CONTENT_CARD_DEFAULT_UPDATE, ({ payload: { id, data } }) =>
      services.updateContentCardDefault(id, data),
    ),
    takeEvery(EntryActionTypes.CONTENT_CARD_DEFAULT_DELETE, ({ payload: { id } }) =>
      services.deleteContentCardDefault(id),
    ),
  ]);
}

